import { api } from "@/lib/api";

const L = (id) => `/crm/leads/${encodeURIComponent(id)}`;
const d = (p) => p.then((r) => r.data);

export const crmMeta = () => d(api.get("/crm/meta"));
export const listLeads = (params) => d(api.get("/crm/leads", { params }));
export const createLead = ({ customerName, country }) => d(api.post("/crm/leads", { customer_name: customerName, country }));
export const getLead = (id) => d(api.get(L(id)));
export const patchLead = (id, body) => d(api.patch(L(id), body));
export const deleteLead = (id) => d(api.delete(L(id)));
export const addNote = (id, text) => d(api.post(`${L(id)}/notes`, { text }));
export const addContact = (id, c) => d(api.post(`${L(id)}/contacts`, c));
export const editContact = (id, cid, c) => d(api.put(`${L(id)}/contacts/${cid}`, c));
export const deleteContact = (id, cid) => d(api.delete(`${L(id)}/contacts/${cid}`));
export const setMainContact = (id, cid) => d(api.post(`${L(id)}/contacts/${cid}/main`));
export const addQuote = (id, q) => d(api.post(`${L(id)}/quotes`, q));
export const deleteQuote = (id, qid) => d(api.delete(`${L(id)}/quotes/${qid}`));
export const uploadQuoteFile = (id, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return d(api.post(`${L(id)}/quote-file`, fd, { headers: { "Content-Type": "multipart/form-data" } }));
};

export const openCrmFile = async (fileId) => {
  const win = window.open("", "_blank");
  const { data } = await api.get(`/crm/files/${fileId}`, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  if (win && !win.closed) win.location.href = url; else window.open(url, "_blank");
};

export const ago = (iso) => {
  if (!iso) return "";
  const days = Math.floor((new Date().setHours(0, 0, 0, 0) - new Date(iso).setHours(0, 0, 0, 0)) / 86400000);
  if (days <= 0) return "Today";
  if (days === 1) return "Yesterday";
  if (days < 30) return `${days} days ago`;
  if (days < 365) return `${Math.floor(days / 30)} mo ago`;
  return `${Math.floor(days / 365)} yr ago`;
};

export const fmtDate = (s) => {
  if (!s) return "—";
  const dt = new Date(s.length === 10 ? `${s}T00:00:00` : s);
  return Number.isNaN(dt.getTime()) ? s : dt.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

export const ordinal = (n) => {
  const s = ["th", "st", "nd", "rd"], v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const STAGE_STYLE = {
  "Identified": "bg-slate-100 text-slate-700",
  "Contacted": "bg-sky-100 text-sky-800",
  "Response Received": "bg-cyan-100 text-cyan-800",
  "RFQ Received": "bg-indigo-100 text-indigo-800",
  "Quoted": "bg-blue-100 text-blue-800",
  "Sample Sent": "bg-amber-100 text-amber-800",
  "Approved": "bg-lime-100 text-lime-800",
  "First PO": "bg-emerald-100 text-emerald-800",
  "Regular Schedule": "bg-green-600 text-white",
  "On Hold": "bg-orange-100 text-orange-800",
  "Lost": "bg-rose-100 text-rose-700",
};

// Mirrors backend quote_totals: Σ qty×rate, or MOQ × average rate when no line has a qty.
export const quoteTotals = (lines, moq) => {
  const priced = lines.filter((l) => l.rate_per_kg !== "" && l.rate_per_kg != null && !Number.isNaN(+l.rate_per_kg));
  const withQty = priced.filter((l) => +l.qty_kg > 0);
  if (withQty.length) return { qty: withQty.reduce((a, l) => a + +l.qty_kg, 0), value: withQty.reduce((a, l) => a + l.qty_kg * l.rate_per_kg, 0), fromMoq: false };
  if (+moq > 0 && priced.length) return { qty: +moq, value: +moq * (priced.reduce((a, l) => a + +l.rate_per_kg, 0) / priced.length), fromMoq: true };
  return { qty: null, value: null, fromMoq: false };
};

export const money = (v, cur) => (v == null ? "—" : `${cur || ""} ${Number(v).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`.trim());

export const hasLamination = (products = []) => products.some((p) => p.includes("Lamination"));
